import { useSelector } from "react-redux";
import {
  makeSelectExitDoorUrl,
  makeSelectIsDirectoryVisibleToAssistants,
  makeSelectOnboardDefaults,
  selectCompanyBadgeUrl,
  selectEnableCompanyBadge,
  selectDisableVPNCheck,
} from "../redux/selectors";

const useCompanySettingsState = () => {
  const { defaultOnboardText, defaultOnboardMedia } = useSelector(
    makeSelectOnboardDefaults,
  );
  const exitURL = useSelector(makeSelectExitDoorUrl);
  const disableVPNCheck = useSelector(selectDisableVPNCheck);
  const companyBadgeURL = useSelector(selectCompanyBadgeUrl);
  const enableCompanyBadge = useSelector(selectEnableCompanyBadge);

  const isDirectoryVisibleToAssistants: boolean = useSelector(
    makeSelectIsDirectoryVisibleToAssistants,
  );

  return {
    defaultOnboardText,
    defaultOnboardMedia,
    companyBadgeURL,
    enableCompanyBadge,
    exitURL,
    disableVPNCheck,
    isDirectoryVisibleToAssistants,
  };
};

export default useCompanySettingsState;
